export enum AppCompanies {
  LACIKONYHA = 'lacikonyha',
  LEADTECH = 'leadtech',
  INTERSNACK = 'intersnack',
  SALESBUS = 'salesbus',
  ZWACK_RETAIL = 'zwack_retail',
  ZWACK_GASTRO = 'zwack_gastro',
  DREHER = 'dreher',
}
